// ============================================================================
// STAY EXTENSION SERVICE
// ============================================================================

import { get, post } from '../client/axiosClient';
import { stayExtensionEndpoints } from '../endpoints/stayExtension.endpoints';
import type { ApiResponse, ID } from '../types';
import type { ExtendStayPreview, ExtendStayRequest } from '../types/stayExtension.types';

class StayExtensionService {
  async getPreview(bookingId: ID, newCheckOutDate: string): Promise<ExtendStayPreview> {
    const response = await get<ApiResponse<ExtendStayPreview>>(
      stayExtensionEndpoints.preview(bookingId, newCheckOutDate),
    );
    if (!response.data?.data) {
      throw new Error(response.data?.message || 'Failed to compute extension preview.');
    }
    return response.data.data;
  }

  async extend(bookingId: ID, payload: ExtendStayRequest): Promise<ExtendStayPreview> {
    const response = await post<ApiResponse<ExtendStayPreview>>(
      stayExtensionEndpoints.extend(bookingId),
      payload,
    );
    if (!response.data?.data) {
      throw new Error(response.data?.message || 'Failed to extend stay.');
    }
    return response.data.data;
  }
}

export const stayExtensionService = new StayExtensionService();
export default stayExtensionService;
